// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBceAcDOYYjs8cstzgTDqn_R7myTIvr5Dc",
  authDomain: "paperplus-14e44.firebaseapp.com",
  projectId: "paperplus-14e44",
  storageBucket: "paperplus-14e44.firebasestorage.app",
  messagingSenderId: "677111095521",
  appId: "1:677111095521:web:adffa9b04c91fa274957a0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
export { auth, db };